import React, { DetailedHTMLProps, SelectHTMLAttributes } from "react";

import Avatar, { AvatarProps, TailwindSize } from "./Avatar";
import Tooltip from "../../components/Tooltip";

export type AvatarGroupProps = {
  items: Omit<AvatarProps, "size">[];
  size?: TailwindSize;
  max?: number;
} & DetailedHTMLProps<SelectHTMLAttributes<HTMLImageElement>, HTMLImageElement>;

const AvatarGroup = React.forwardRef<HTMLDivElement, AvatarGroupProps>(
  ({ items, size = 6, max = 5 }, ref) => {
    return (
      <div className="flex flex-shrink-0 sm:mt-0">
        <Tooltip label={items.map(({ name }) => name).join(", ")}>
          <div className="flex -space-x-2 overflow-hidden" ref={ref}>
            {items.map(({ ref: _, ...itemProps }, index) =>
              index > max - 1 ? null : (
                <Avatar
                  key={index}
                  {...itemProps}
                  size={size}
                  imgClassName={index === 0 ? "" : "-ml-1"}
                />
              )
            )}
          </div>
        </Tooltip>
        {items.length > max && (
          <span className="flex flex-col justify-center ml-1 text-xs text-dark-100">
            + {items.length - max}
          </span>
        )}
      </div>
    );
  }
);

export default React.memo(AvatarGroup);
